/**
 * Vuex store for snackbar.
 * Use displaySnackbar mutation to provide the snackbar with an appropriate text, display the snackbar for 4seconds and hide it.
 */
const DEFAULT_DURATION_IN_MILLIS = 3000;

let timeout;

// --------------------------------------------------------------------------------------------------------------------------------------------------------------
const state = {
  isOpen: false,
  text: '',
};

// --------------------------------------------------------------------------------------------------------------------------------------------------------------
const getters = {};

// --------------------------------------------------------------------------------------------------------------------------------------------------------------
const mutations = {
  setIsOpen(state, isOpen) {
    state.isOpen = isOpen;
  },
  /**
   * Sets the respective states to trigger display (or if already displayed append a message) of the snackbar with the action.userInfo or if not defined, with a simple text
   * @param {object} action an
   * @param {string} text either an action object or a text property needs to be provided.
   */
  displaySnackbar(state, { action, text }) {
    // internal timer
    const startTimer = () => {
      timeout = setTimeout(() => {
        state.isOpen = false;
      }, DEFAULT_DURATION_IN_MILLIS);
    };

    // Show snackbar and hide after DEFAULT_DURATION_IN_MILLIS
    const showSnackbar = ({ action, text }) => {
      if ((action && action.userInfo) || text) {
        state.isOpen = true;
        state.text = action ? action.userInfo : text;
        startTimer();
      }
    };
    // append a message and restart timer, that is extend display for another 4 seconds
    const appendMessage = ({ action, text }) => {
      if ((action && action.userInfo) || text) {
        state.text = state.text + '<br>' + (action ? action.userInfo : text);
        if (timeout) clearTimeout(timeout);
        startTimer();
      }
    };

    if (state.isOpen) {
      appendMessage({ action, text }); // if snackbar is already open await DEFAULT_DURATION_IN_SECONDS + 100ms and try again
    } else {
      showSnackbar({ action, text }); // display snackbar immediately
    }
  },
};

// --------------------------------------------------------------------------------------------------------------------------------------------------------------
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
